export const URL_APP_STORE = 'https://apps.apple.com/au/app/kintell/id1419104805'
export const URL_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.kintell.kintellapp'
